import { executeRequest, request } from "utils/proxy";
import { API_FEED_JOBS } from "globals/constants";
import { spUrl } from "utils";


export const feedJobs = {
	/**
	 * @param {{id: string}} params
	 * @param {{}?} options
	 */
	getStatus: (params, options) => request(spUrl(`${API_FEED_JOBS}/status/${params.id}`), options),

	/**
	 * @param {{}} body
	 * @param {{}?} options
	 */
	exportCsv: (body, options) => executeRequest(
		spUrl(`${API_FEED_JOBS}/start-export`),
		{
			method: "POST",
			body: JSON.stringify(body),
			headers: {
				"Content-Type": "application/json"
			}
		},
		options,
	),
};
